import React, {FC, useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {fetchData, toasterrormsg} from '../../../reusable'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import Fancybox from '../Fancybox'
import {SpaceRentalDetailsHeader} from './SpaceRentalDetailsHeader'

const SpaceImages: FC = () => {
  const location = useLocation()
  const spacerentalId = (location.state as any)?.spacerentalId || ''
  const [spaceRenatalDetails, setSpacerentalDetails] = useState([])

  // spaceRenatal Details api call
  const spaceDetailsApiCall = async () => {
    var param: any = {
      spacerentalId: String(spacerentalId),
    }
    var response: any = await fetchData('vendor/public/spaceDetails', param)

    if (response.status == '200') {
      setSpacerentalDetails(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }

  // for fancy box
  const opts = {
    fullScreen: {
      autoStart: true, // Auto-start in full-screen mode
    },
    Thumbs: false,
    // Other options...
  }
  useEffect(() => {
    spaceDetailsApiCall()
  }, [])
  return (
    <>
      <PageTitle breadcrumbs={[]}>Space Rental Images</PageTitle>
      <ToastContainer />
      <SpaceRentalDetailsHeader />
      {spaceRenatalDetails.map((spaceRenatal: any, index: any) => {
        return (
          <>
            <div className='row g-5 g-xl-10 mb-5 mb-xl-10' key={index}>
              {spaceRenatal['images'].length != 0 ? (
                <div className='col-xl-12'>
                  {/* <!--begin::Engage widget 7--> */}
                  <div className='card card-flush h-xl-100'>
                    {/* <!--begin::Header--> */}
                    <div className='card-header pt-7'>
                      {/* <!--begin::Title--> */}
                      <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bold text-gray-900'>
                          spaceRenatal Images
                        </span>
                      </h3>
                      {/* <!--end::Title--> */}
                    </div>
                    {/* <!--end::Header--> */}

                    {/* <!--begin::Card body--> */}
                    <div className='card-body pt-7'>
                      {/* <!--begin::Row--> */}
                      <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                        {spaceRenatal['images'].map((images: any, index: any) => {
                          return (
                            <>
                              <Fancybox options={opts}>
                                {/* <!--begin::Col--> */}
                                <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                  {/* <!--begin::Overlay--> */}
                                  <a
                                    data-fancybox='gallery'
                                    className='d-block overlay'
                                    data-fslightbox='lightbox-hot-sales'
                                    href={images['mediaPath']}
                                  >
                                    {/* <!--begin::Image--> */}
                                    <div
                                      className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                      style={{
                                        height: '266px',
                                        backgroundImage: `url('${images['mediaPath']}')`,
                                      }}
                                    ></div>
                                    {/* <!--end::Image--> */}

                                    {/* <!--begin::Action--> */}
                                    <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                      <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                    </div>
                                    {/* <!--end::Action--> */}
                                  </a>
                                  {/* <!--end::Overlay-->*/}
                                </div>
                                {/* <!--end::Col--> */}
                              </Fancybox>
                            </>
                          )
                        })}
                      </div>
                      {/* <!--end::Row-->*/}
                    </div>
                    {/* <!--end::Card body--> */}
                  </div>
                  {/* <!--end::Engage widget 7--> */}
                </div>
              ) : (
                <div className='col-xl-12'>
                  {/* <!--begin::Engage widget 1--> */}
                  <div className='card h-md-100' dir='ltr'>
                    {/* <!--begin::Body--> */}
                    <div className='card-body d-flex flex-column flex-center'>
                      {/* <!--begin::Heading--> */}
                      <div className='mb-2'>
                        {/* <!--begin::Illustration--> */}
                        <div className='py-10 text-center'>
                          <img
                            src={toAbsoluteUrl('/media/svg/illustrations/easy/2.svg')}
                            className='theme-light-show h-125px'
                            alt=''
                          />
                          <img
                            src={toAbsoluteUrl('/media/svg/illustrations/easy/2-dark.svg')}
                            className='theme-dark-show h-125px'
                            alt=''
                          />
                        </div>
                        {/* <!--end::Illustration--> */}
                      </div>
                      {/* <!--end::Heading--> */}
                    </div>
                    {/* <!--end::Body--> */}
                  </div>
                  {/* <!--end::Engage widget 1--> */}
                </div>
              )}
            </div>
          </>
        )
      })}
    </>
  )
}

export {SpaceImages}
